import React from 'react';

import { IconButton } from '@material-ui/core';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { StarOutline, ArrowRight, ArrowLeft } from '@material-ui/icons';
import file from '../../../assets/excelFile.svg'

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import { customers } from '../../../models/Analytics';

interface TabsProps {
  entity: string;
  rank_by: string;
  tab_id: string;
  customers: customers[];
  handleChange: (type: string, event: any) => void;
  handleExport: (type: string) => void;
};

const NextArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Next"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.rightArrow }}
    >
      <ArrowRight
        color="primary" className={`${styles.rightArrowIcon}`}
      />
    </IconButton>
  );
}

const PrevArrow = (props: any) => {
  const { newClass, onClick } = props;
  return (
    <IconButton
      aria-label="Prev"
      onClick={onClick}
      className={newClass}
      classes={{ root: styles.leftArrow }}
    >
      <ArrowLeft
        color="primary" className={`${styles.leftArrowIcon}`}
      />
    </IconButton>
  );
}

const settings = {
  infinite: false,
  dots: false,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [

    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
  ]
};

const Tabs = (props: TabsProps) => {
  let i = 1;
  const getTopCustoner: Array<JSX.Element> = props.customers.map((item: customers, index: number) => {
    return (
      <div className={`${styles.tcWrapper} ${item.id != props.tab_id ? styles.tcDisabled : ''}`} onClick={() => props.handleChange('tab_id', item.id)}>
        <div className={`${styles.topCustomer}`}>
          <span className={`${styles.tcStarWrapper}`}>
            <StarOutline
              classes={{
                root: styles.tcStar
              }}
            />
            <span className={`${styles.tcNo}`}>{i++}</span>
          </span>
          {props.rank_by == 'wgt' && (
            <>
              <span><b>{Math.round(item.wgt)}</b></span>
              <small>KG</small>
            </>
          )}
          {props.rank_by == 'pcs' && (
            <>
              <span><b>{item.pcs}</b></span>
              <small>PCS</small>
            </>
          )}
          {props.rank_by == 'awbs' && (
            <>
              <span><b>{item.awbs}</b></span>
              <small>AWBS</small>
            </>
          )}
          {props.rank_by == 'orders' && (
            <>
              <span><b>{item.orders}</b></span>
              <small>Orders</small>
            </>
          )}
        </div>
        <div className={commonStyles.mt2}><b>{item.name}</b></div>
      </div>
    )
  });

  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={commonStyles.fSpaceBtw}>
        <h5 className={styles.heading}> Top Customers</h5>
        <div className={`${styles.fileImg}`}>
          <img src={file} alt="file" onClick={() => props.handleExport('tab')} />
        </div>
      </div>
      <div>
        <Slider {...settings} className={`${styles.slider}`}>
          {getTopCustoner}
        </Slider>
      </div>
    </div>
  );
};

export default Tabs;